import { PROFILE } from '../../data/profile';
import SectionHeading from '../SectionHeading/SectionHeading';
import Certificates from './Certificates';
import './Education.css';

// Irish honours degrees award a first for 70% and above
const FIRST_CLASS = 70;

export default function Education() {
  const edu = PROFILE.education;
  const { classification, credits, modules } = edu.yearThree;
  const [result, grade] = classification.split(/\s*\((.+)\)/);

  return (
    <section id="education" className="section education" aria-labelledby="education-title">
      <div className="container">
        <SectionHeading
          title="Education"
          id="education-title"
          intro="My degree, my strongest third-year grades and the short courses I have done alongside it."
        />
        <div className="edu-card" data-reveal>
          <div className="edu-main">
            <p className="edu-eyebrow">{edu.school} · Graduating {edu.graduation}</p>
            <h3>{edu.degree.split(',')[0]}</h3>
            <p>Back for the fourth and final year from October 2026.</p>
          </div>
          <div className="edu-result">
            <span className="edu-result-label">3rd year result</span>
            <strong className="edu-grade">{result}</strong>
            {grade && <span className="edu-grade-short">{grade}</span>}
            <div className="edu-credits">
              <div className="edu-progress" role="img" aria-label={`${credits.earned} of ${credits.total} credits earned`}>
                <span style={{ '--p': credits.earned / credits.total }} />
              </div>
              <span className="tabular">{credits.earned} / {credits.total} credits</span>
            </div>
          </div>
        </div>

        <div className="edu-modules" data-reveal>
          <div className="edu-modules-head">
            <h3>Strongest 3rd-year modules</h3>
            <span className="edu-legend"><i aria-hidden="true" /> {FIRST_CLASS}% first-class line</span>
          </div>
          <ul>
            {modules.map((module, i) => (
              <li key={module.title} style={{ '--g': module.grade / 100, '--i': i, '--line': FIRST_CLASS / 100 }}>
                <span className="edu-module-name">{module.title}</span>
                <strong className="tabular">{module.grade}%</strong>
                <span className="edu-bar" aria-hidden="true" />
              </li>
            ))}
          </ul>
        </div>
        <Certificates />
      </div>
    </section>
  );
}
